import {ActionTypes} from '../../actions';
import createReducer from '../../../common/util/createReducer';

const INITIAL_STATE = {
  'list': [],
  'loading': false,
  'profileSelected': null,
};

export const wtsProfiles = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_WTS_PROFILES]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_PROFILES]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_WTS_PROFILES_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CREATING_WTS_PROFILES]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.CREATED_WTS_PROFILES]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CREATED_WTS_PROFILES_FAILED]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATING_WTS_PROFILES]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_WTS_PROFILES]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATED_WTS_PROFILES_FAILED]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CHANGE_WTS_PROFILE_SELECTED]: (state, action) => ({
      ...state,
      'profileSelected': action.payload,
    }),
  })(state, action);
};
